var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Common',{attrs:{"event":_vm.event,"add-time":0},on:{"end":_vm.end,"realEnd":_vm.realEnd}},[(_vm.showQue)?_c('CommonQue',{staticClass:"que-wrap",attrs:{"params":_vm.params}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }